// @ts-check
import DescriptionTextSetting from "Components/Common/Settings/DescriptionTextSetting";
import SettingsBlock from "Components/Common/Settings/SettingsBlock";
import SwitcherSetting from "Components/Common/Settings/SwitcherSetting";
import usersServerSettingsStore from "Stores/usersServerSettingsStore";
import { observer } from "mobx-react";
import React, { Component } from "react";

class MeetUsersServerSettings extends Component {
    componentDidMount() {
        usersServerSettingsStore.LoadSettings()
    }

    render() {
        return ([
            <SettingsBlock
                id='application-update-block'
                key='application-update-block'
                title="Обновление приложений">

                <SwitcherSetting
                    key='notify-new-version'
                    title='Уведомить устройства о появлении новой версии "ЭОС Совещания"'
                    helperText='Данные уведомления доступны для iOS и Android приложений.'
                    disabled={usersServerSettingsStore.settings.notifyDeviceInfo.totalDevicesCount === 0}
                    value={usersServerSettingsStore.settings.notifyDeviceInfo.notifyNewVersion}
                    onChanged={(value) => usersServerSettingsStore.SetNotifyNewVersion(value)} />

                <DescriptionTextSetting
                    key='notify-new-version-result'
                    text={`Параметр включен для ${usersServerSettingsStore.settings.notifyDeviceInfo.notifiableDevicesCount} из ${usersServerSettingsStore.settings.notifyDeviceInfo.totalDevicesCount} устройств`} />

            </SettingsBlock>
            ,
            <SettingsBlock
                id='notification-block'
                key='notification-block'
                title="Уведомления">

                <SwitcherSetting
                    key='push-settings'
                    title="Push-уведомления:"
                    disabled={false}
                    value={usersServerSettingsStore.settings.enablePushNotification}
                    onChanged={(value) => usersServerSettingsStore.SetPushNotification(value)} />

            </SettingsBlock>
        ])
    }
}

export default observer(MeetUsersServerSettings);